"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
require("./Checkbox.scss");
var Checkbox = function (props) {
    var _a = formik_1.useField(props), meta = _a[1];
    var isSubmitting = formik_1.useFormikContext().isSubmitting;
    var dusk = props.dusk, label = props.label, name = props.name, _b = props.allowSubmittingDisabledState, allowSubmittingDisabledState = _b === void 0 ? true : _b, rest = __rest(props, ["dusk", "label", "name", "allowSubmittingDisabledState"]);
    return (react_1.default.createElement("label", { className: "inline-flex mr-4" },
        react_1.default.createElement("div", { className: "my-1 flex" },
            react_1.default.createElement(formik_1.Field, __assign({ type: "checkbox", name: name, className: classnames_1.default('form-checkbox', { 'form-input--error': !!meta.error }), disabled: isSubmitting && allowSubmittingDisabledState }, rest))),
        label && react_1.default.createElement("span", { className: "pl-2 my-1" }, label)));
};
exports.default = Checkbox;
//# sourceMappingURL=index.js.map